export default __webpack_public_path__ + "static/media/the-cube-title.aa9495f0.svg";